// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, WORKSPACE_TYPES, CHANNEL_TYPES, CONFERENCE_ROOM_TYPES, MESSAGE_TYPES } = require('@bcm/constants');
const { ConferenceRoomTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  workspaceType: Joi.string().valid( ...Object.keys(WORKSPACE_TYPES) ).required(),
  workspaceId: Joi.string().required(),
  channelType: Joi.string().valid( ...Object.keys(CHANNEL_TYPES) ).required(),
  channelId: Joi.string().required(),
  conferenceRoomType: Joi.string().valid( ...Object.keys(CONFERENCE_ROOM_TYPES) ).optional(),
  conferenceRoomId: Joi.string().required(),
  participants: Joi.array().items( Joi.object({
    sessionId: Joi.string().required(),
    userId: Joi.string().required(),
    userName: Joi.string().required(),
  }).required() ).optional(),
  transcript: Joi.array().items({
    timestamp: Joi.string().optional(),
    text: Joi.string().optional(),
    sessionId: Joi.string().optional(),
    type: Joi.string().valid( ...Object.keys( MESSAGE_TYPES) ).optional(),
  }).required(),
  transcriptSummary: Joi.string().optional(),
  recordingPath: Joi.string().optional(),
  exp: Joi.string().required(),
  ownerId: Joi.string().required(),
};

// Define class
class ConferenceRoomTranscript extends ConferenceRoomTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.conferenceRoomTranscript.buildPk(obj.workspaceId, obj.channelId),
      identifiers.conferenceRoomTranscript.buildSk(obj.state, obj.workspaceType, obj.workspaceId, obj.channelType, obj.channelId, obj.conferenceRoomType, obj.conferenceRoomId),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.ConferenceRoomTranscript = ConferenceRoomTranscript;
exports.conferenceRoomTranscriptSchema = schema;